import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AD2_REQUEST_DEDUPE = process.env.REACT_APP_AD2_REQUEST_DEDUPE !== 'false';
const inflight = new Map();

const dedupe = (key, request) => {
  if (!AD2_REQUEST_DEDUPE) return request();
  if (inflight.has(key)) return inflight.get(key);
  const pending = request().finally(() => inflight.delete(key));
  inflight.set(key, pending);
  return pending;
};

export const galleryService = {
  async listAssets({ assetType = 'all', limit = 100, offset = 0, q = '' } = {}) {
    const params = new URLSearchParams({ limit, offset });
    if (assetType && assetType !== 'all') params.append('asset_type', assetType);
    if (q && q.trim()) params.append('q', q.trim()); // AP-12 · buscar por nombre
    return dedupe(`assets:${params}`, async () => {
      const res = await axios.get(`${API}/gallery?${params}`);
      return res.data;
    });
  },

  async getStorageStats() {
    return dedupe('storage', async () => {
      const res = await axios.get(`${API}/gallery/storage`);
      return res.data;
    });
  },

  async bulkDelete(assetIds) {
    const res = await axios.delete(`${API}/gallery/bulk`, {
      data: { asset_ids: assetIds },
    });
    return res.data;
  },

  async getBulkDownloadUrls(assetIds) {
    const res = await axios.post(`${API}/gallery/bulk-download-urls`, { asset_ids: assetIds });
    return res.data;
  },

  async createStorageUpgrade(originUrl) {
    const res = await axios.post(`${API}/payments/storage-upgrade`, { origin_url: originUrl });
    return res.data;
  },
};
